import React from "react";
import {
  Box,
  Pagination,
  PaginationProps,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  pagination: {
    display: "flex",
    justifyContent: "center",
    marginTop: theme.spacing(3),
  },
  paginationItem: {
    "& .Mui-selected:hover": {
      backgroundColor: "transparent",
      color: theme.palette.primary.main,
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: theme.palette.primary.main,
    },
    "& .Mui-selected": {
      backgroundColor: "transparent",
      color: theme.palette.primary.main,
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: theme.palette.primary.main,
    },
  },
}));

interface CardPaginationProps extends Omit<PaginationProps, "shape" | "color"> {
  siblingCount?: number;
  boundaryCount?: number;
  className?: string;
}
export const CardPagination = ({
  siblingCount: propSiblingCount,
  boundaryCount: propBoundaryCount,
  className,
  ...props
}: CardPaginationProps) => {
  const s = useStyles();
  const { breakpoints } = useTheme();
  const smUp = useMediaQuery(breakpoints.up("sm"));
  const mdUp = useMediaQuery(breakpoints.up("md"));
  const siblingCount = propSiblingCount ?? (smUp ? 2 : 1);
  const boundaryCount = propBoundaryCount ?? (mdUp ? 2 : smUp ? 1 : 0);
  return (
    <Box className={clsx(className, s.pagination)}>
      <Pagination
        shape="rounded"
        color={"primary"}
        siblingCount={siblingCount}
        boundaryCount={boundaryCount}
        className={s.paginationItem}
        {...props}
      />
    </Box>
  );
};
